import gql from 'graphql-tag'

export const CONTRACT_PRODUCT_TEMPLATE_VERSION_UPDATE_MUTATION = gql`
    mutation contractProductTemplateVersionUpdate(
        $id: ID!
        $productTemplateVersion: Float!
    ) {
        contractProductTemplateVersionUpdate(
            id: $id
            product_template_version: $productTemplateVersion
        ) {
            id
            currentContractInformation {
                product {
                    template {
                        version
                        form_configuration
                        template_configuration
                    }
                }
                productTemplate {
                    version
                    form_configuration
                    template_configuration
                }
            }
        }
    }
`
